module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Akira Yamamoto Profile","short_name":"AK prof","start_url":"/","background_color":"#FFFFFF","theme_color":"#272727","display":"standalone","icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"bcdc516fe61235be1dbc2da8c59ac068"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
